import React from "react";
import { Card } from "@/components/ui/card";

export function StatCard({ label, value, icon: Icon, accent = "clinical", tid }) {
  const colors = {
    clinical: "bg-sky text-clinical",
    emerald: "bg-emeraldbrand/10 text-emeraldbrand",
    amber: "bg-amberbrand/10 text-amberbrand",
    navy: "bg-navy/5 text-navy",
  };
  return (
    <Card className="p-5" data-testid={tid}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</p>
          <p className="mt-2 font-heading text-2xl font-bold text-navy">{value}</p>
        </div>
        {Icon && <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${colors[accent]}`}><Icon className="h-5 w-5" /></div>}
      </div>
    </Card>
  );
}

export function PageTitle({ title, subtitle, children }) {
  return (
    <div className="mb-6 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
      <div>
        <h2 className="font-heading text-2xl font-bold tracking-tight text-navy">{title}</h2>
        {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function statusColor(status) {
  const s = (status || "").toUpperCase();
  if (["APPROVED", "ACTIVE", "PLACED", "COMMISSION_PAID", "COMMISSION_APPROVED", "PAYMENT_CONFIRMED"].includes(s)) return "bg-emeraldbrand/10 text-emeraldbrand";
  if (["REJECTED", "NOT_QUALIFIED", "SUSPENDED", "INACTIVE", "CLOSED"].includes(s)) return "bg-slate-200 text-slate-600";
  if (["COMPLIANCE_REVIEW", "MORE_INFORMATION_REQUIRED", "AGREEMENT_REQUIRED", "REVIEW", "COMPLIANCE_REVIEW_REQUIRED", "OPEN"].includes(s)) return "bg-amberbrand/10 text-amberbrand";
  return "bg-sky text-clinical";
}
